import React, { useState } from "react";
import cn from "classnames";
import Icon from "components/Icon";
import PropTypes from "prop-types";

export default function FormSection(props) {
    const { name, icon, description, action, collapsed, children } = props;
    const [isCollapsed, toggle] = useState(collapsed);
    return (
        <div
            className={cn("form-section", {
                [`variant-${props.variant}`]: props.variant !== "default",
            })}
        >
            <div
                className={"form-section-header"}
                onClick={collapsed !== null ? () => toggle(!isCollapsed) : null}
            >
                <div className={"form-section-heading"}>
                    <div className={"form-section-title"}>
                        {icon && (
                            <div className={"form-section-icon"}>
                                <Icon>{icon}</Icon>
                            </div>
                        )}
                        <div className={"form-section-name"}>{name}</div>
                    </div>
                    {description && (
                        <div className={"form-section-description"}>
                            {description}
                        </div>
                    )}
                </div>
                {action && (
                    <div className={"form-section-action"}>{action}</div>
                )}
                {collapsed !== null && (
                    <div className={"form-section-toggle"}>
                        <Icon>
                            {isCollapsed
                                ? "mui-chevron_right"
                                : "mui-expand_more"}
                        </Icon>
                    </div>
                )}
            </div>
            {React.Children.count(children) > 0 && !isCollapsed && (
                <div>{children}</div>
            )}
        </div>
    );
}

FormSection.propTypes = {
    variant: PropTypes.oneOf(["contained", "default"]),
};
FormSection.defaultProps = {
    variant: "contained",
    collapsed: null,
};
